<template>
  <div class="container">
    <PublicHeader :totalName="$t('common').Notice" />
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getContentList"
        :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`notice${dIndex}`"
          @click="$router.push({ name: 'Detail', query: { Name: $t('common').Notice, id: dItem.contentLocalizationId } })">
          <img class="iiimg" v-if="dItem.image" :src="isHttp(dItem.image) ? dItem.image : baseUrl + dItem.image">
          <img class="iiimg" v-else src="@/assets/img/new_local.jpg">
          <div class="left">
            <div class="name">{{ dItem.localizationTitle }}</div>
            <div class="time">{{ dItem.occurrenceTime }}</div>
          </div>
          <!-- <van-icon name="arrow" size="13" color="var(--ntext_color)" /> -->
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'
import systemApi from '@/api/system'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      baseUrl: window.baseURL,
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
        type: '1'
      },
      oList: [],
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getContentList()
  },
  methods: {
    isHttp(url) {
      return /^https?:\/\//.test(url)
    },
    // 获取内容列表
    async getContentList() {
      if (this.isRun) return
      this.isRun = true
      const res = await systemApi.getContentList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
  .container {
    min-height: 100vh;
    width: 100%;
    padding: 60px 15px 15px 15px;
    background: var(--background_color);
  
    .listInfo {
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
  
        .iiimg {
          width: 120px;
          height: 70px;
          object-fit: cover;
          border-radius: 7px;
        }
  
        .left {
          margin-left: 10px;
          width: calc(100% - 130px);
  
          .name {
            font-size: 13px;
            font-weight: bold;
            color: var(--text_color);
            line-height: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
  
          .time {
            margin-top: 15px;
            font-size: 12px;
            color: var(--ntext_color);
          }
        }
      }
    }
  }
  </style>
